// Frontend permission helpers — mirror of backend `permissions.py`.

/** Check if the current user can perform an action on a module. */
export function userCan(user, moduleId, actionId) {
  if (!user) return false;
  if (user.role === "admin" && user.is_super_admin) return true;
  if (user.role === "admin") {
    // Admin non-super has every functional action; MQA stays super-only.
    if (moduleId === "MQA" || moduleId === "MREPO") return false;
    return true;
  }
  const actions = (user.effective_actions || {})[moduleId];
  if (!Array.isArray(actions)) return false;
  return actions.includes(actionId);
}

/** Convenience: does the user have ANY access to the module (any action)? */
export function userHasModule(user, moduleId) {
  if (!user) return false;
  return (user.effective_modules || []).includes(moduleId);
}
